import { Box, Drawer, Divider, styled } from '@mui/material';

export const DependentPictureStyled = styled(Box)({
  '& svg': {
    padding: '0.5rem',
  },
});

export const FamilyDrawerStyled = styled(Drawer)(({ theme }) => ({
  zIndex: 2000,
  '& .MuiDrawer-paper': {
    width: '400px',
    padding: theme.spacing(7),
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
}));

export const AvatarFamilyDrawerStyled = styled(Drawer)(({ theme }) => ({
  zIndex: 2000,
  '& .MuiDrawer-paper': {
    width: '400px',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
}));

export const AvatarFamilyDrawerBoxStyled = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  position: 'relative',
  padding: theme.spacing(0),
}));

export const FirstDrawerDividerMargin = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(5, 0),
}));

export const ButtonLinkStyled = styled('div')({
  '& button span:first-child': {
    textDecoration: 'underline',
  },
});

export const FamilyDisplayPictureDrawerStyled = styled(Drawer)(({ theme }) => ({
  zIndex: 2001,
  '& .MuiDrawer-paper': {
    width: '400px',
    padding: theme.spacing(7),
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
}));

export const FamilyDisplayPictureDrawerDivider = styled(Divider)(
  ({ theme }) => ({
    marginTop: theme.spacing(20),
    marginBottom: theme.spacing(5),
  })
);
